import { Action, InstrumentInfoState } from './types'

export const setInstrumentInfo = (instrumentInfo: InstrumentInfoState) => ({
    type: 'SET_INSTRUMENT_INFO',
    payload: {
        instrumentInfo,
    },
})

const instrumentInfoReducer: React.Reducer<InstrumentInfoState, Action> = (
    state: InstrumentInfoState,
    action: Action
) => {
    switch (action.type) {
        case 'SET_INSTRUMENT_INFO':
            return {
                ...state,
                ...action.payload.instrumentInfo,
            }

        default:
            return state
    }
}

export default instrumentInfoReducer
